import { useCallback, useState } from "react";

import { DYNAMICS_ENRICHMENT_INTEREST_STORAGE_KEY } from "app/pages/sales-intelligence/modules/manage-integrations/constants/storageKeys";
import manageIntegrationsTrackingService from "app/pages/sales-intelligence/modules/manage-integrations/services/tracking";
import localStorageService from "app/pages/sales-intelligence/services/localStorageService";

interface IStoredInterestState {
    sentAt: number;
}

interface IUseDynamicsEnrichmentInterestResult {
    isSubmitted: boolean;
    isThanksModalOpen: boolean;
    handleInterestedClick: () => void;
    handleCloseThanksModal: () => void;
}

const readPersistedIsSubmitted = (): boolean => {
    const stored = localStorageService.getState<IStoredInterestState>(DYNAMICS_ENRICHMENT_INTEREST_STORAGE_KEY);

    return !!stored?.sentAt;
};

export const useDynamicsEnrichmentInterest = (): IUseDynamicsEnrichmentInterestResult => {
    const [isSubmitted, setIsSubmitted] = useState(() => readPersistedIsSubmitted());
    const [isThanksModalOpen, setIsThanksModalOpen] = useState(false);

    const handleInterestedClick = useCallback(() => {
        if (isSubmitted) {
            return;
        }

        manageIntegrationsTrackingService.trackDynamicsEnrichmentInterested();
        localStorageService.setState(DYNAMICS_ENRICHMENT_INTEREST_STORAGE_KEY, { sentAt: Date.now() });
        setIsSubmitted(true);
        setIsThanksModalOpen(true);
    }, [isSubmitted]);

    const handleCloseThanksModal = useCallback(() => {
        setIsThanksModalOpen(false);
    }, []);

    return {
        isSubmitted,
        isThanksModalOpen,
        handleInterestedClick,
        handleCloseThanksModal,
    };
};
